/** Whether the content-history feature exists on this machine at all. */

import { useEffect, useState } from 'react'

import { apiService } from '../../../services/api'

/** Whether the sibling content repo is reachable, so the UI can hide the feature. */
export function useHistoryAvailability(bookId: string | undefined, isAuthor: boolean): boolean {
  const [available, setAvailable] = useState(false)

  useEffect(() => {
    if (!bookId || !isAuthor) {
      setAvailable(false)
      return
    }

    let cancelled = false
    apiService
      .getHistoryAvailability(bookId)
      .then((result) => {
        if (!cancelled) {
          setAvailable(result.available)
        }
      })
      .catch(() => {
        if (!cancelled) {
          setAvailable(false)
        }
      })

    return () => {
      cancelled = true
    }
  }, [bookId, isAuthor])

  return available
}
